import { Country, IReferenceData } from 'src/shared/types/Common';
import { BooleanYesNo } from '../constants/common';

export const getCountryName = (list: Country[], key: string | undefined) => {
  if (!key) return '';
  return list.find((country) => country.countryCode === key)?.countryName ?? '';
};

export const displayYesNo = (value: boolean | undefined) => {
  if (value == undefined) return BooleanYesNo.No;
  return value ? BooleanYesNo.Yes : BooleanYesNo.No;
};

export const getReferenceDataDescription = (list: IReferenceData[], key: string | undefined) => {
  if (!key) return '';
  return list.find((item) => item.code === key)?.description ?? '';
};

export const getRemoteInstanceRedirectURL = (target: string) => {
  return `${window.FN_CONFIG.OIDC_CONFIGURATION?.authority || ''}/remote-redirect?target=${encodeURIComponent(target)}`;
};
